import { ILanguageSelectorProps } from "@faire/web--source/ui/LanguageSelector/common";
import React, { Suspense } from "react";

export const LazyLanguageSelector = (
  props: Omit<ILanguageSelectorProps, "userToken">
) => (
  <Suspense fallback={null}>
    <LazyLanguageSelectorBase {...props} />
  </Suspense>
);

const LazyLanguageSelectorBase = React.lazy<
  React.ComponentType<ILanguageSelectorProps>
>(() =>
  import(
    /* webpackChunkName: "self-serve-language-dropdown" */ "./ClickableLanguageSelector"
  ).then((module) => {
    return {
      default: module.ClickableLanguageSelector,
    };
  })
);
